

import mixx from "../../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  name: "terminales",
  data() {
    return {
      loading: false,
      loading2: false,
      ter_name: "",
      ter_chekeds: [],
      terminales_to_check: [],
      term_asociadas: [],
      tbv: null,
      tbv2: null,
    };
  },

  computed: {
    excelTerminales: function () {
      return (
        "/config/terminales/?dsis=" + window.sssdi
      );
    },
    excelTerminalesAsociadas: function () {
      return (
        "/config/terminales/asociadas/?dsis=" + window.sssdi
      );
    }
  },
  mounted: function () {
    this.tbv = $("#ventas").DataTable({
      dom: 'Bfrtip',
      buttons: ["excelHtml5"],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
            language: {
        search: "Filtrar:"
    }
    });

    this.tbv2 = $("#venta2s").DataTable({
      dom: 'Bfrtip',
      buttons: ["excelHtml5"],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      language: {
        search: "Filtrar:"
    }
    });

    $('.dt-input').addClass('form-control mb-4');
     $('.dt-input').css("margin-bottom","10px");

    window.comp1 = this;
    $(".box").boxWidget();
    this.terminales();
    this.asociadas();
  },

  methods: {
    terminales() {
      this.tbv.clear();

      this.loading = true;
      this.ter_chekeds = [];
      this.$http
        .post(
          "/config/terminales/",
        )
        .then(response => {
          for (let i = 0; i < response.data.data.length; i++) {
            let ds =
              `<input type="checkbox"  onclick="window.comp1.chk_change('${response.data.data[i][0]}',${response.data.data[i][1]})"/>`;
            this.tbv.row.add([
              response.data.data[i][0],
              response.data.data[i][2],
              ds
            ]);
          }
          this.tbv.draw();
          this.loading = false;
        });
    },

    chk_change(ter, idc) {
      let n = -1;

      for (let i = 0; i < this.ter_chekeds.length; i++) {
        if (this.ter_chekeds[i][0] == ter) {
          n = i;
          break;
        }
      }

      if (n > -1) {
        this.ter_chekeds.splice(n, 1);
      } else {
        this.ter_chekeds.push([ter, idc]);
      }
      console.log(this.ter_chekeds);
    },

    asociadas() {


      this.tbv2.clear();

      this.loading2 = true;
      this.$http
        .post(
          "/config/terminales/asociadas/")
        .then(response => {
          for (let i = 0; i < response.data.data.length; i++) {
            let ds =`<button type="button" onclick="window.comp1.del_term_nm('${response.data.data[i][1]}',${response.data.data[i][2]})" class="btn btn-danger"><i class="fa fa-close"></i></button>`;
            this.tbv2.row.add([
              response.data.data[i][1],
              response.data.data[i][0],
              response.data.data[i][3],
              ds
            ]);
          }
          this.tbv2.draw();
          this.loading2 = false;
        });
    },

    del_term_nm(ter, idc) {
      this.loading2 = true;
      this.$http
        .post(
          "SERVER/scd/configs/",
          {
            a: "delt",
            t: ter,
            url: idc
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status == 1) {
            this.showNotification({
              msj: "Se elminó el nombre de temrinal",
              bg: "bg-green"
            });
          } else {
            this.showNotification({
              msj: "Error al elmininar terminal, contacte con soporte.",
              bg: "bg-red"
            });
          }

          this.terminales();
          this.asociadas();

          this.loading2 = false;
        });
    },

    asoci_ter() {
      if (this.ter_chekeds.length > 0) {
        if (this.ter_name != "") {
          this.loading = true;
          this.$http
            .post(
              "SERVER/scd/configs/",
              {
                a: "asst",
                n: this.ter_name,
                t: this.ter_chekeds
              },
              {
                withCredentials: true
              }
            )
            .then(response => {
              if (response.data.status == 1) {
                this.showNotification({
                  msj: "Terminales asociadas",
                  bg: "bg-green"
                });
              } else {
                this.showNotification({
                  msj: "Se produjo algun error al gesiontar las temrinales",
                  bg: "bg-red"
                });
              }

              this.terminales();
              this.asociadas();
              this.loading = false;
            });
        } else {
          this.showNotification({
            msj: "Escriba algun alias para las terminales seleccionadas",
            bg: "bg-red"
          });
        }
      } else {
        this.showNotification({
          msj: "Seleccione almenos una terminal",
          bg: "bg-red"
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/configs/termianles/main/index.js